import { render } from "./ServiceItsNormalGalleryComp.vue?vue&type=template&id=4c151f66&scoped=true"
import script from "./ServiceItsNormalGalleryComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsNormalGalleryComp.vue?vue&type=script&lang=js"

import "./ServiceItsNormalGalleryComp.vue?vue&type=style&index=0&id=4c151f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c151f66"]])

export default __exports__